// taken from cart voucher/discounts contract
export enum VOUCHER_TYPE {
  'VOUCHER' = 'voucher',
  'REDPOINTS' = 'redpoints'
}
